import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BookOpenCheck, LogOut, Settings, LayoutGrid } from "lucide-react";

export function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-[#e6e4dd] bg-[#f6f5f1]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2.5 group" data-testid="header-logo">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#0f172a] text-[#f6f5f1] transition-transform group-hover:scale-105">
            <BookOpenCheck className="h-5 w-5" />
          </div>
          <span className="font-display text-xl tracking-tight">Publishing Coach</span>
        </Link>

        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/dashboard")} data-testid="nav-catalog-btn"
                className="hidden sm:inline-flex text-[#475569] hover:bg-slate-900 hover:text-white">
                <LayoutGrid className="h-4 w-4 mr-1.5" /> Catalog
              </Button>
              <Button variant="ghost" onClick={() => navigate("/settings")} data-testid="nav-settings-btn"
                className="text-[#475569] hover:bg-slate-900 hover:text-white">
                <Settings className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Settings</span>
              </Button>
              <div className="ml-1 hidden md:flex items-center gap-2 pl-2">
                {user.picture ? (
                  <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover" />
                ) : (
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#d97706] text-white text-sm font-semibold">
                    {(user.name || user.email || "?")[0].toUpperCase()}
                  </div>
                )}
              </div>
              <Button variant="ghost" size="icon" onClick={handleLogout} data-testid="nav-logout-btn"
                className="text-[#475569] hover:bg-rose-600 hover:text-white">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn"
                className="text-[#475569] hover:bg-slate-900 hover:text-white">Sign in</Button>
              <Button onClick={() => navigate("/login")} data-testid="nav-start-btn"
                className="rounded-full bg-[#0f172a] text-white hover:bg-[#1e293b]">Start free</Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
